import { useEffect, useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { api } from '../lib/api'
import { setToken } from '../lib/auth'
import Button from '../components/ui/Button'
import Input from '../components/ui/Input'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [err, setErr] = useState('')
  const [oauthEnabled, setOAuthEnabled] = useState(false)
  const [busy, setBusy] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const kickTok = params.get('kick_token')
    if (kickTok) {
      setToken(kickTok)
      const noChannel = params.has('kick_no_channel')
      window.history.replaceState({}, '', window.location.pathname)
      // Kanal bağlanamadıysa dashboard'a query ile yolla — orada toast/uyarı göstersin.
      navigate(noChannel ? '/dashboard?kick_no_channel=1' : '/dashboard')
      return
    }
    const kickErr = params.get('kick_error')
    if (kickErr) {
      setErr(kickErr)
      window.history.replaceState({}, '', window.location.pathname)
    } else if (params.has('session_expired')) {
      setErr('Oturum süresi doldu, tekrar giriş yap.')
      window.history.replaceState({}, '', window.location.pathname)
    }
    api<{ enabled: boolean }>('/api/auth/kick/enabled')
      .then((r) => setOAuthEnabled(r.enabled))
      .catch(() => setOAuthEnabled(false))
  }, [])

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setErr('')
    setBusy(true)
    try {
      const res = await api<{ token: string }>('/api/auth/login', {
        method: 'POST',
        body: JSON.stringify({ email, password }),
      })
      setToken(res.token)
      navigate('/dashboard')
    } catch (e) {
      setErr((e as Error).message || 'Hata')
    } finally {
      setBusy(false)
    }
  }

  function loginWithKick() {
    const apiBase = import.meta.env.VITE_API_BASE || 'http://localhost:8080'
    window.location.href = `${apiBase}/api/auth/kick/login/start`
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 mb-6">
            <span className="w-8 h-8 rounded-md bg-gradient-to-br from-[var(--color-accent)] to-[#8a93f0] flex items-center justify-center text-white text-base font-bold">
              P
            </span>
            <span className="text-xl font-semibold tracking-tight">pixelkit</span>
          </div>
          <h1 className="text-2xl font-semibold mb-1">Tekrar hoş geldin</h1>
          <p className="text-sm text-[var(--color-text-muted)]">Hesabına giriş yap</p>
        </div>

        <div className="rounded-lg border border-[var(--color-border)] bg-[var(--color-surface)] p-6 space-y-4">
          {oauthEnabled && (
            <>
              <Button
                onClick={loginWithKick}
                variant="success"
                size="lg"
                className="w-full"
              >
                <span className="text-base">●</span>
                Kick ile devam et
              </Button>
              <div className="flex items-center gap-3">
                <div className="flex-1 h-px bg-[var(--color-border)]" />
                <span className="text-xs text-[var(--color-text-subtle)]">veya</span>
                <div className="flex-1 h-px bg-[var(--color-border)]" />
              </div>
            </>
          )}

          <form onSubmit={submit} className="space-y-3">
            <div>
              <label className="block text-xs font-medium mb-1.5 text-[var(--color-text-muted)]">Email</label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="ornek@email.com"
                required
                autoFocus
              />
            </div>
            <div>
              <label className="block text-xs font-medium mb-1.5 text-[var(--color-text-muted)]">Şifre</label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>
            {err && (
              <div className="text-xs px-3 py-2 rounded bg-[var(--color-danger)]/10 text-[var(--color-danger)] border border-[var(--color-danger)]/30">
                {err}
              </div>
            )}
            <Button type="submit" variant="primary" size="lg" className="w-full" disabled={busy}>
              {busy ? 'Giriş yapılıyor…' : 'Giriş yap'}
            </Button>
          </form>
        </div>

        <div className="text-center text-sm text-[var(--color-text-muted)] mt-6 space-y-1">
          <div>
            Hesabın yok mu?{' '}
            <Link to="/register" className="text-[var(--color-accent-hover)] hover:underline">
              Kayıt ol
            </Link>
          </div>
          <div>
            <Link to="/forgot-password" className="text-xs hover:underline">
              Şifremi unuttum
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
